import header from './header'
export default { header}



// WEBPACK FOOTER //
// ./src/components/index.js